var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"singleBox"},[_c('RadioGroup',{on:{"on-change":_vm.checkChange},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}},_vm._l((_vm.options),function(item,index){return _c('Radio',{key:item.title,attrs:{"circle":"","label":item.title}},[_c('span',[_vm._v(_vm._s(item.title))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }